var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
/**
 * Adaptor return default options for raw options.
 */
export function useDefaultAdaptor(adaptor) {
  return function (options) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return deepMix({}, adaptor.apply(void 0, [options].concat(rest)), options);
  };
}
/**
 * Adaptor return options override raw options.
 */
export function useOverrideAdaptor(adaptor) {
  return function (options) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    return deepMix({}, options, adaptor.apply(void 0, [options].concat(rest)));
  };
}
export function mergeData(dataDescriptor, dataValue) {
  if (!dataDescriptor) return dataValue;
  if (Array.isArray(dataDescriptor)) return dataDescriptor;
  var _dataDescriptor$value = dataDescriptor.value,
    value = _dataDescriptor$value === void 0 ? dataValue : _dataDescriptor$value,
    rest = __rest(dataDescriptor, ["value"]);
  return Object.assign(Object.assign({}, rest), {
    value: value
  });
}